import { useState } from "react";
import { issuanceMonitorWidget, SORT } from "../../../../../../constants";
import {
    DashboardWidget,
    DashboardWidgetContent,
    DashboardWidgetHeader,
} from "../../../../../dashboard/widget";
import { Table } from "../../../../../bidding/common/table";
import { Pagination } from "../../../../../dashboard/tables/Pagination";
import { useSortedList } from "../../../../../../effects";
import { ColumnBuilder } from "../../../../../bidding/common/table/columns/column-builder/ColumnBuilder";
import { PortfolioConcentration } from "./concentration-columns";

type TColumnName = keyof PortfolioConcentration;

interface Props {
    chartName: string;
    listItems: PortfolioConcentration[];
    columns: ColumnBuilder<PortfolioConcentration>[];
}

export function ConcentrationTable({
    chartName,
    listItems,
    columns,
}: Props) {
    const [page, setPage] = useState(1);
    const [sortBy, setSortBy] = useState<TColumnName>("volume");
    const [sortDirection, setSortDirection] = useState(SORT.DESC);

    const [sortedDataItems] = useSortedList(listItems, sortBy, sortDirection);

    const handleSortChange = (field: TColumnName, direction: string) => {
        setSortBy(field);
        setSortDirection(direction);
    };

    const onPageChanged = (selectedPage: number) => setPage(selectedPage);

    const renderTable = () => {
        const getTableWithData = (items: PortfolioConcentration[]) => (
            <Table
                onSort={handleSortChange}
                defaultSortBy={sortBy}
                defaultSortByDirection={sortDirection}
                dataItems={items}
                columns={columns}
                className="data-list-striped"
            />
        );

        return sortedDataItems.length > issuanceMonitorWidget.itemsOnPage ? (
            <Pagination
                list={sortedDataItems}
                itemsOnPage={issuanceMonitorWidget.itemsOnPage}
                currentPage={page}
                onPageChanged={onPageChanged}
            >
                {(items: PortfolioConcentration[]) => getTableWithData(items)}
            </Pagination>
        ) : (
            getTableWithData(sortedDataItems)
        );
    };

    return (
        <>
            {sortedDataItems.length > 0 &&
                <div className="col-item">
                    <DashboardWidget title={chartName} className="top-issuers">
                        <DashboardWidgetHeader className="heading-wrap">
                            <h3>{chartName}</h3>
                        </DashboardWidgetHeader>
                        <DashboardWidgetContent>
                            {renderTable()}
                        </DashboardWidgetContent>
                    </DashboardWidget>
                </div>}
        </>
    );
}
